export default {
  employee: "Employee",
  tablet: "Tablet",
  admin: "Administrator",
};
